// eslint-disable-next-line import/prefer-default-export
export const GetProgramEnrollmentsSelector = ({
  programEnrollments: { GetProgramEnrollments }
}) => GetProgramEnrollments;

export const PostProgramEnrollmentsSelector = ({
  programEnrollments: { PostProgramEnrollments }
}) => PostProgramEnrollments;
